import {getApiConfig} from "../config";

function apiClientSettings(isMultipart?: boolean): object {
    const {accessToken, basicAuthUser, basicAuthPass} = getApiConfig();

    const extraHeaders = {};
    if (basicAuthUser && basicAuthPass) {
        extraHeaders['Authorization'] = 'Basic ' + window.btoa(basicAuthUser + ':' + basicAuthPass);
    }
    extraHeaders['Widget-Access-Token'] = accessToken;

    const headers = isMultipart ? {
        ...extraHeaders,
    } : {
        'Content-Type': 'application/json',
        ...extraHeaders,
    };

    return {
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: headers,
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    }
}

export async function get(url: string = '', queryParams = {}): Promise<any> {
    const filteredParams = {};

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            filteredParams[key] = value;
        }
    });

    return makeRequest('GET', url + '?' + (new URLSearchParams(filteredParams)));
}

export async function post(url: string = '', data: object = {}): Promise<any> {
    return makeRequest('POST', url, data);
}

export async function postCustomUrl(url: string = '', data: object = {}): Promise<any> {
    return makeRequestCustomUrl('POST', url, data);
}

export async function callDelete(url: string = '', data: object = {}): Promise<any> {
    return makeRequest('DELETE', url, data);
}

async function makeRequestCustomUrl(method: string, url: string = '', data: object = {}): Promise<any> {
    const isMultipart = data instanceof FormData;
    return new Promise(async (resolve, reject) => {
        const response = await fetch(url, {
            ...apiClientSettings(isMultipart),
            method: method, // *GET, POST, PUT, DELETE, etc.
            body: method === 'POST' ? JSON.stringify(data) : undefined // body data type must match "Content-Type" header
        });

        response.text().then(body => {
            const validStatus = response.status >= 200 && response.status < 300;
            if (validStatus) {
                return resolve({
                    data: body.length && JSON.parse(body) || null,
                });
            }

            return reject(new ApiError(body));
        }).catch(err => {
            reject(err);
        });
    });
}

async function makeRequest(method: string, url: string = '', data: object = {}): Promise<any> {
    const apiBaseUrl = getApiConfig().apiBaseUrl;
    if (!apiBaseUrl) {
        return;
    }
    const isMultipart = data instanceof FormData;
    const formDataOrJson = isMultipart ? data : JSON.stringify(data);

    return new Promise(async (resolve, reject) => {
        const response = await fetch(apiBaseUrl + url, {
            ...apiClientSettings(isMultipart),
            method: method, // *GET, POST, PUT, DELETE, etc.
            body: method === 'POST' ? formDataOrJson : undefined // body data type must match "Content-Type" header
        } as RequestInit & { body?: BodyInit | ReadableStream<Uint8Array> }); // specify the expected type for the body property

        response.text().then(body => {
            const validStatus = response.status >= 200 && response.status < 300;
            if (validStatus) {
                return resolve({
                    data: body.length && JSON.parse(body) || null,
                });
            }

            return reject(new ApiError(body));
        }).catch(err => {
            reject(err);
        });
    });
}

export class ApiError extends Error {
    readonly body: string

    constructor(body: string) {
        super();
        this.name = "ApiError";
        this.body = body;
    }

    get data(): any {
        if (this.body.length > 0) {
            return JSON.parse(this.body);
        }
    }
}

function MyError(message) {
    this.message = message;
}

MyError.prototype = new Error();
